export let sections = [
    {
        title: 'FAU Leipzig',
        subsections: [
            {
                title: 'Kollaboration',
                tools: [
                    {
                        title: 'Discourse',
                        url: 'https://forum.fau.org/',
                        img: 'images/discourse.png',
                    },
                    {
                        title: 'FAU Cloud',
                        url: 'https://cloud.fau.org/apps/files/?dir=/VAB Leipzig',
                        img: 'https://cloud.fau.org/apps/files/img/app.svg?v=30472561',
                        color: '#1195DD',
                    },
                    {
                        title: 'Mail',
                        url: 'https://webmail.fau.org/',
                        img: 'images/mail.svg',
                        color: '#f7b603'
                    },
                    {
                        title: 'Kalender',
                        url: 'https://cloud.fau.org/apps/calendar/dayGridMonth/now',
                        img: 'images/calendar_icon.svg',
                        color: 'hsl(4, 82%, 56%)'
                    },
                    {
                        title: 'FAU Pad',
                        url: 'https://pad.fau.org/',
                        img: 'images/pad.svg',
                    },
                ]
            },
            {
                title: 'Informationen',
                tools: [
                    {
                        title: 'Mandate & Strukturen',
                        url: 'https://cloud.fau.org/f/55810',
                        img: 'https://upload.wikimedia.org/wikipedia/commons/e/e6/Noun_project_organization_icon.svg',
                        color: '#FFDD57'
                    }
                ]
            },
            {
                title: 'Videokonferenz',
                tools: [
                    {
                        title: 'Senfcall',
                        url: 'https://public.senfcall.de/',
                        img: 'images/senfcall.svg',
                        color: '#FFDD57'
                    }
                ]
            },
        ]
    },
    {
        title: 'FAU Leipzig öffentliche Kanäle',
        subsections: [
            {
                tools: [
                    {
                        title: 'Website FAU Leipzig',
                        url: 'https://leipzig.fau.org/',
                        img: 'images/WWW.svg'
                    },
                    {
                        title: 'Twitter FAU Leipzig',
                        url: 'https://twitter.com/FAU_Leipzig',
                        img: 'images/twitter.svg'
                    },
                    {
                        title: 'Twitter Betriebsgruppe Dominoeffekt',
                        url: 'https://twitter.com/BGdominoeffekt',
                        img: 'images/bgdominoeffektround.jpg'
                    },
                    {
                        title: 'Instagram',
                        url: 'https://www.instagram.com/fau_leipzig/',
                        img: 'images/instagram.png'
                    },
                    {
                        title: 'Youtube',
                        url: 'https://www.youtube.com/channel/UCLVDBH_8Y3HxgZp1KfbX5xQ/featured',
                        img: 'images/youtube.svg',
                        color: '#f00'
                    },
                    {
                        title: 'Facebook',
                        url: 'https://www.facebook.com/FAULeipzig/',
                        img: 'images/Facebook_F_icon.svg',
                        color: '#0D7EC4'
                    },
                ]
            }
        ]
    },
    {
        title: 'FAU Föderation',
        subsections: [
            {
                tools: [
                    {
                        title: 'Website',
                        url: 'https://www.fau.org/',
                        img: 'images/WWW.svg'
                    },
                    {
                        title: 'Bundesweites Forum',
                        url: 'https://forum.fau.org/',
                        img: 'images/forum.svg'
                    },
                    {
                        title: 'Bundesweite Tools',
                        url: 'https://intern.fau.org/',
                        img: 'https://static.fau.org/images/fau_logo_rounded.svg'
                    },
                    {
                        title: 'Extranet (veraltet)',
                        url: 'https://extranet.fau.org/ug/lokal/leipzig',
                        img: 'images/extranet.svg'
                    },
                ]
            }
        ]
    }
]
